import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-read",
  "use": "icon-read-usage",
  "viewBox": "0 0 25 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 23\" id=\"icon-read\"><path d=\"M0 0h25v3H0V0zm0 5h25v3H0V5zm0 5h25v3H0v-3zm0 5h25v3H0v-3zm0 5h25v3H0v-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol